import RailHoverBubble from '@/shared/components/RailHoverBubble/RailHoverBubble'
import useRailHoverLabel from '@/shared/components/RailHoverBubble/useRailHoverLabel'
import HopTimusAvatar from '../HopTimusAvatar/HopTimusAvatar'
import useHopTimusRailEntry from './useHopTimusRailEntry'
import { HopTimusRailButton } from './styled-components'

const HopTimusRailEntry = () => {
  const { hidden, label, hoverLabel, open, onClick } = useHopTimusRailEntry()
  const { anchorRef, geometry, show, hide } = useRailHoverLabel<HTMLButtonElement>()

  if (hidden) return null

  return (
    <>
      <HopTimusRailButton
        ref={anchorRef}
        type='button'
        data-rail-module='hop-timus'
        aria-label={label}
        aria-expanded={open}
        aria-keyshortcuts='Control+K Meta+K'
        onClick={onClick}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
      >
        <HopTimusAvatar />
      </HopTimusRailButton>
      <RailHoverBubble geometry={geometry} label={hoverLabel} side='left' />
    </>
  )
}

export default HopTimusRailEntry
